<template>
  <div class="paddedPage">
    <div style="display: flex; align-items: center; justify-content: start; gap: 10px; margin-top: -10px;">
      <h3 style="color: var(--primary-700)">
        Timers
      </h3>
      <Button size="small" severity="secondary" :class="buttonClass('systemTimers')" @click="selectedTableKey = 'systemTimers'">
        <div>
          System
        </div>
      </Button>
      <Button size="small" severity="secondary" :class="buttonClass('binTimers')" @click="selectedTableKey = 'binTimers'">
        <div>
          Bins
        </div>
      </Button>
    </div>
    <MultiColumnTable :tableKey="selectedTableKey" style="margin-top: 10px;"></MultiColumnTable>
  </div>
</template>

<script setup>
import { ref } from "vue";
import MultiColumnTable from "./MultiColumnTable.vue";

let selectedTableKey = ref("binTimers");

function buttonClass(tableKey) {
  return {
    selected: tableKey == selectedTableKey.value
  }
}
</script>

<style scoped>
button div {
  width: 160px;
}
.selected {
  color: #222;
  background: var(--blue-200);
  border: 1px solid var(--blue-300);
}
</style>